export default __webpack_public_path__ + "locales/ko-KR/Settings.json?hash=7823dd5cc38d35361db27f854b332e48";